// Single entry point for Wasapi English strings (imported once from i18n/locale/en/index.js).
import common from '../common/i18n/en.json';
import crm from '../crm/i18n/en.json';
import dashboardApps from '../dashboard-apps/i18n/en.json';
import reactions from '../reactions/i18n/en.json';
import capi from '../capi/i18n/en.json';
import forward from '../forward/i18n/en.json';
import scheduled from '../scheduled-messages/i18n/en.json';
import campaigns from '../campaigns/i18n/en.json';
import windowTimers from '../window-timers/i18n/en.json';
import flows from '../flows/i18n/en.json';
import appointments from '../appointments/i18n/en.json';
import internalChats from '../internal-chats/i18n/en.json';
import projects from '../projects/i18n/en.json';
import templates from '../templates/i18n/en.json';

export default {
  ...common,
  ...crm,
  ...dashboardApps,
  ...reactions,
  ...capi,
  ...forward,
  ...scheduled,
  ...campaigns,
  ...windowTimers,
  ...flows,
  ...appointments,
  ...internalChats,
  ...projects,
  ...templates,
};
